import { Directive, Input, OnDestroy, OnChanges, inject } from '@angular/core';

import { SortBySelectorComponent } from '../sort-by-selector/sort-by-selector.component';
import { SortByOption, SortByOptionHelper } from '../sort-by-selector/sort-by-selector.domain';
import { TableStateBaseDirective } from './table-state-base.directive';

@Directive({
  selector: '[tdWbTableCardState]'

})
export class TableCardStateDirective extends TableStateBaseDirective implements OnChanges, OnDestroy {
  private sortBySelectorComponent: SortBySelectorComponent;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input('tdWbTableCardState')
  set tableId(value: string) {
    this.stateId = value;
  }

  constructor() {
    const sortBySelectorComponent = inject(SortBySelectorComponent, { host: true });

    super(sortBySelectorComponent.sortByChange);

    this.sortBySelectorComponent = sortBySelectorComponent;
  }

  ngOnChanges(): void {
    const sorts = this.getSorts();
    if (sorts !== undefined && sorts.length > 0) {
      this.sortBySelectorComponent.setSortBy(sorts[0]);
    }
  }

  ngOnDestroy(): void {
    this.destroy();
  }

  onSort(sort: SortByOption): void {
    this.setSorts([SortByOptionHelper.convertToTableSort(sort)]);
  }
}
